const appEnvRaw = import.meta.env.VITE_APP_ENVIRONMENT;

if (typeof appEnvRaw !== "string" || appEnvRaw.trim() === "") {
  throw new Error(
    "VITE_APP_ENVIRONMENT is required and must be non-empty. Set it for this build (for example in .env or CI).",
  );
}

/** Application deploy environment (shared across the app). */
export const appEnvironment = appEnvRaw.trim();

export const isProduction = appEnvironment === "production";

const apiBaseUrlRaw = import.meta.env.VITE_API_BASE_URL;

if (typeof apiBaseUrlRaw !== "string" || apiBaseUrlRaw.trim() === "") {
  throw new Error(
    "VITE_API_BASE_URL is required and must be non-empty. Set it for this build (for example in .env or CI).",
  );
}

/** Backend API base URL (e.g. ``https://api.example.com/api/v1``). */
export const API_BASE_URL = apiBaseUrlRaw.trim();
